//App
import useForm from "../../../hooks/useForm";
import { CampaignContributionsReportContext } from "../CampaignContributionContainer";
import {
  CampaignContributionReportContextData,
  CampaignContributionReportProps,
} from "../../../../types";

const useCampaignContributionsReport = (
  props: CampaignContributionReportProps
) => {
  return useForm<
    CampaignContributionReportContextData,
    CampaignContributionReportProps
  >(CampaignContributionsReportContext, props);
};

export default useCampaignContributionsReport;
